import errors from './errors.js'

export default {
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    promocode: '',
    addon:'cultivate',
    original_cost:0,
    cost:0,
    errors: errors,
    submit: 'Sign Up'
}
